export default __webpack_public_path__ + "static/media/raise1.c1ee4ffa.mp3";